import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarehouseTransfer } from "src/models/Products/WarehouseTransfer.models";

interface WarehouseTransferState {
    warehouseTransfers: IWarehouseTransfer[];
    warehouseTransferToEdit: IWarehouseTransfer | null;
}

const initialState: WarehouseTransferState = {
    warehouseTransfers: [],
    warehouseTransferToEdit: null,
};

const WarehouseTransferSlice = createSlice({
    name: "WarehouseTransfer",
    initialState,
    reducers: {
    setWarehouseTransferList: (
        state,
        action: PayloadAction<IWarehouseTransfer[]>
    ) => {
        state.warehouseTransfers = action.payload;
    },
    concatListWarehouseTransfer: (
        state: WarehouseTransferState,
        action: PayloadAction<IWarehouseTransfer[]>
    ) => {
        state.warehouseTransfers = [
            ...state.warehouseTransfers.concat(action.payload),
        ];
    },
    setWarehouseTransferToEdit: (
        state,
        action: PayloadAction<IWarehouseTransfer | null>
    ) => {
        state.warehouseTransferToEdit = action.payload;
    },
    addWarehouseTransfer: (state, action: PayloadAction<IWarehouseTransfer>) => {
        state.warehouseTransfers.push(action.payload);
    },
    updateWarehouseTransfer: (state, action: PayloadAction<IWarehouseTransfer>) => {
        let itemIndex = state.warehouseTransfers.findIndex(
            item => item.warehouseTransferId === action.payload.warehouseTransferId
        );
        if (itemIndex !== -1) state.warehouseTransfers[itemIndex] = action.payload;
    },
    deleteWarehouseTransfer: (state, action: PayloadAction<number>) => {
        const newArray = state.warehouseTransfers.filter(
            item => item.warehouseTransferId !== action.payload
        );
        state.warehouseTransfers = newArray;
    },
    },
});

export const {
    setWarehouseTransferList,
    concatListWarehouseTransfer,
    setWarehouseTransferToEdit,
    addWarehouseTransfer,
    updateWarehouseTransfer,
    deleteWarehouseTransfer,
} = WarehouseTransferSlice.actions;

export default WarehouseTransferSlice.reducer;